import React, { useState } from 'react';
import { Icon } from 'assets/icons';
import ConfirmationDialog from 'app/shared/dialogs/confirmation';
import { Spacer } from 'app/member/layouts/generic';
import { GridColumn, GridRow } from 'app/member/layouts/grid';
import { GenerateBlogButton } from './generate';
import { BlogListPage } from './list/list';
import { BlogViewPage } from './view';
import styles from './blogs.module.css';

export const BlogsView = () => {
  const [selected_blog, setSelectedBlog] = useState(null);
  const [is_editing_blog, setIsEditingBlog] = useState(false);
  const [show_switch_warning, setShowSwitchWarning] = useState(false);
  const [pending_blog, setPendingBlog] = useState(null);
  const [refresh_key, setRefreshKey] = useState(0);
  const [pending_refreshes, setPendingRefreshes] = useState(0);

  const is_refreshing = pending_refreshes > 0;

  const handleRefresh = () => {
    if (is_refreshing) return;

    setPendingRefreshes(selected_blog ? 2 : 1);
    setRefreshKey((key) => key + 1);
  };

  const handleRefreshComplete = () => {
    setPendingRefreshes((count) => (count > 0 ? count - 1 : 0));
  };

  const handleSelectBlog = (next_blog) => {
    if (!next_blog) return;

    if (selected_blog?.id === next_blog.id) return;

    if (is_editing_blog) {
      setPendingBlog(next_blog);
      setShowSwitchWarning(true);
      return;
    }

    setSelectedBlog(next_blog);
  };

  const handleSwitchConfirmation = (proceed) => {
    setShowSwitchWarning(false);

    if (proceed) {
      if (pending_blog) setSelectedBlog(pending_blog);
      setIsEditingBlog(false);
    }

    setPendingBlog(null);
  };

  return (
    <>
      <GridRow num_of_columns={2}>
        <GridColumn span={1}>
          <p className={styles.toolbarHint}>
            Published posts hand off to the email and social agents automatically.
          </p>
        </GridColumn>
        <GridColumn span={1}>
          <div className={styles.toolbarActions}>
            <button
              type="button"
              className={styles.refreshBtn}
              onClick={handleRefresh}
              disabled={is_refreshing}
              title="Reload the blog list and the selected post"
            >
              <span className={is_refreshing ? styles.refreshIconSpinning : styles.refreshIcon}>
                <Icon name="refresh" width={15} height={15} />
              </span>
              <span>{is_refreshing ? 'Refreshing…' : 'Refresh'}</span>
            </button>
            <GenerateBlogButton />
          </div>
        </GridColumn>
      </GridRow>
      <Spacer multiple={3} />

      <div className={styles.layout}>
        <div className={styles.listPane}>
          <BlogListPage
            selected_id={selected_blog?.id}
            refresh_key={refresh_key}
            onSelect={handleSelectBlog}
            onRefreshComplete={handleRefreshComplete}
          />
        </div>
        <div className={styles.previewPane}>
          {selected_blog ? (
            <BlogViewPage
              blog={selected_blog}
              refresh_key={refresh_key}
              onEditModeChange={setIsEditingBlog}
              onRefreshComplete={handleRefreshComplete}
            />
          ) : (
            <div className={styles.emptyState}>
              <div className={styles.emptyIcon}>
                <Icon name="blogs" width={22} height={22} />
              </div>
              <p className={styles.emptyTitle}>No blog selected</p>
              <p className={styles.emptyHint}>Select a blog from the list to preview it here.</p>
            </div>
          )}
        </div>
      </div>
      <ConfirmationDialog
        is_open={show_switch_warning}
        message="You have unsaved edits. Switching posts will discard those changes. Continue?"
        callback={handleSwitchConfirmation}
      />
    </>
  );
};
